exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  min-height: calc(100vh - 215px);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/wired-messenger-accounts/wired-messenger-accounts.component.css
// module id = ../../../../../src/app/components/organization/accounts/wired-messenger-accounts/wired-messenger-accounts.component.css
// module chunks = main